export default __webpack_public_path__ + "static/media/iui23-33-f.6d34e570.pdf";